const Style = ({ isMobile }) => `
<style>
            :host {
              display: flex;
              flex-direction: column;
              gap: 0px;
              height: 100%;
              ${
                isMobile
                  ? 'padding: 30px 12px;'
                  : `
                    padding-top: 30px;
                    padding-right: 20px;
                    padding-bottom: 30px;
                    padding-left: 0;`
              }

              width: 100%;
              min-width: 342px;
              max-width: 700px;
            }

            img {
              max-width: 100%;
              max-height: 100%;
            }
            .four-step-child-content-container {
                display: flex;
                flex-direction: column;
                gap: 20px;
            }
            .four-step-child-image {
                height: 300px;
                align-self: stretch;
                border-radius: 11px 11px 0px 0px;
            }
            .four-step-button-container {
                display: flex;
                gap:48px;
                justify-content: center;
            }

            @media screen and (max-width: 1000px) {
                .four-step-button-container {
                    display: flex;
                    gap:30px;
                    justify-content: center;
                    padding-bottom: 20px;
                }
            }

            .four-step-item-button-container {
                display: flex;
                flex-direction: column;
                align-items: center;
                gap: 10px;
            }
            .four-step-button {
                border-radius: 99px;
                border: 1px solid #3A3E43;
                width: 40px;
                height: 40px;
                background-color: rgba(255, 0, 0, 0);
                display: inline-flex;
                align-items: center;
                justify-content: center;
                color: #0a0a0a;
            }
            .four-step-button:active {
                background-color: #D2EAE5;
            }

            .four-step-desktop-container {
                width: 100vw;
                display: flex;
                gap: 24px;
                justify-content: center;
            }

            .four-step-desktop-image-container {
                width: 660px;
                height: 600px;
                background-repeat: no-repeat;
                background-size: cover;
                border-radius: 11px;

            }

            .four-step-desktop-text-container {
                width: 580px;
                display: flex;
                flex-direction: column;
                gap: 15px;
                padding: 60px 50px;
                border-radius: 11px;
            }
          </style>
`;

export default Style;
